import axiosInstance from "../../../api/axiosInstance";

export const fetchVocabularyGroups = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    const res = await axiosInstance.get("/public/vocabulary-groups", { params: cleaned });
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || "Failed to fetch vocabulary groups",
    };
  }
};

export const fetchVocabularyGroupById = async (id) => {
  try {
    const res = await axiosInstance.get(`/public/vocabulary-groups/${id}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return {
      status: err.response?.status || 500,
      data: null,
      message: err.response?.data?.message || "Failed to fetch vocabulary group",
    };
  }
};